if (!customElements.get('info-box')) {
  customElements.define('info-box', class InfoBox extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector('.hero-image-info-button');
      const closeButton = this.querySelector('.hero-image-info-box__close');
      button.addEventListener('click', this.toggleExpand.bind(this));
      closeButton.addEventListener('click', this.toggleExpand.bind(this));
    }

    toggleExpand() {
      this.classList.toggle('expanded');
    }
  });
}
